var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoHomeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.84 15.73"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.64 5.84L8.77.09a.51.51 0 00-.58 0L5.7 1.88V.49A.49.49 0 005.21 0H3.42a.49.49 0 00-.5.49v3.22a.33.33 0 000 .15l-2.74 2a.49.49 0 00-.12.69.49.49 0 00.4.21.46.46 0 00.29-.1l.3-.21v7.47a1.83 1.83 0 001.83 1.84h11a1.84 1.84 0 001.84-1.84v-7.5l.29.21a.5.5 0 00.69-.11.48.48 0 00-.06-.68zM3.91 1h.81v1.58l-.81.58zm5.91 13.74H6.69V9.89a1.92 1.92 0 013.13 0v4.85zm5-.85a.85.85 0 01-.85.85H10.8v-5a.54.54 0 00-.06-.25 3 3 0 00-2.48-1.4 3 3 0 00-2.49 1.4.54.54 0 00-.06.25v5h-2.8a.85.85 0 01-.85-.85V5.71L8.48 1.1l6.3 4.6z",
    fill: "#fdc800",
    "data-name": "Capa 1"
  }))));
}

export default SvgCoHomeinline;